/**
 * contiene la información para el manejo de Un.
 */
export const defaultUn = () => {
    return {
        noun: '',
        riesgo_principal: '',
        principalRiskTemporary: '',
        riesgo_secundario: '',
        riesgo_secundario1: '',
        imagen_principal: null,
        imagen_secundario: null,
        imagen_secundario1: null,
        slq_gre_id: null
    }
}

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    selectedUn: defaultUn(),

    optprincipal: [],
    optsecundario: [],
    optsecundario1: [],

    txtprincipal: '',
    txtsecundario: '',
    txtsecundario1: '',

    rotul:{
        tipoRotulo:''
    },

    guiaRespuestaEmergencia: [],
    cargando_select: false,
    dirRotulo:''
}
